import React from 'react';
import { Container, Text } from './style';

export const InfoIcon = ({ onClick }) => {
    return (
        <Container onClick={onClick}>
            <Text>i</Text>
        </Container>
    )
}